import React, { useEffect, useMemo, useState } from 'react';
import { H2, H3 } from 'primitives/appTitle';
import AppSection from 'primitives/appSection';

import {
  AppInternalLink,
  AppInternalPath,
  AppInternalPaths,
} from 'primitives/appLink';

import Swiper from 'swiper';
//@ts-ignore
import { device } from 'helpers/helpers';

import { ShText } from '@shoootin/translations';
import { FrontCommonMessages } from '../../appCommonTranslations';
import useIntersectionObserverInitializer from '../../hooks/useIntersectionObserverInitializer';
import { AppGatsbyImage, AppGatsbyImageFluid } from '../../primitives/appImage';
import usePrestationMainImages from '../../queries/usePrestationMainImages';
import { forceImageMaxWidth } from 'appGatsbyImageUtils';
import { mapValues } from 'lodash';
import { PrestationName } from '../../appConstants';
import { ShIntlMessageDefinition } from '@shoootin/translations/src';

export interface Prestation {
  name: PrestationName;
  // imgUrl: string;
  title: ShIntlMessageDefinition;
  text: ShIntlMessageDefinition;
  target: AppInternalPath;
}

export const PrestationsList: Prestation[] = [
  {
    name: 'matterport',
    title: FrontCommonMessages.scan,
    text: FrontCommonMessages.scanDesc,
    target: AppInternalPaths.service('matterport'),
    //imgUrl: MatterportHeader,
  },
  {
    name: 'drone',
    title: FrontCommonMessages.drone,
    text: FrontCommonMessages.droneDesc,
    target: AppInternalPaths.service('drone'),
    //imgUrl: DroneHeader,
  },
  {
    name: 'photo',
    title: FrontCommonMessages.photo,
    text: FrontCommonMessages.photoDesc,
    target: AppInternalPaths.service('photo'),
    //imgUrl: PhotoHeader,
  },
  {
    name: 'video',
    title: FrontCommonMessages.video,
    text: FrontCommonMessages.videoDesc,
    target: AppInternalPaths.service('video'),
    //imgUrl: VideoHeader,
  },
];

const usePrestationOtherImages = () => {
  const mainImages = usePrestationMainImages();
  return useMemo(() => {
    return mapValues(mainImages, (image) => forceImageMaxWidth(image, 400));
  }, [mainImages]);
};

const PrestationOthers = ({
  prestationName,
}: {
  prestationName: PrestationName;
}) => {
  const prestationToDisplay = PrestationsList.filter(
    (presta) => presta.name !== prestationName,
  );
  const images = usePrestationOtherImages();

  useEffect(() => {
    const options = {
      spaceBetween: 20,
      slidesPerView: device().isMobile ? 1.5 : 3,
      loop: false,
    };
    new Swiper('.prestation-others-list', options);
  });

  return (
    <>
      <AppSection
        className="prestation-others darker left"
        header={
          <H2>
            <ShText message={FrontCommonMessages.prestationOthers} />
          </H2>
        }
      >
        <div className="prestation-others-list swiper-container">
          <div className="swiper-wrapper">
            {prestationToDisplay.map((prestation, i) => (
              <PrestationOther
                key={i}
                prestation={prestation}
                image={images[prestation.name]}
              />
            ))}
          </div>
        </div>
      </AppSection>
    </>
  );
};

const PrestationOther = ({
  prestation,
  image,
}: {
  prestation: Prestation;
  image: AppGatsbyImageFluid;
}) => {
  return (
    <div className="swiper-slide">
      <figure className="prestation-others-list__card">
        <span className="prestation-others-list__cover">
          <AppGatsbyImage fluid={image} style={{ position: 'absolute' }} />
        </span>
        <figcaption className="prestation-others-list__caption">
          <H3>
            <ShText message={prestation.title} />
          </H3>
          <p>
            <ShText message={prestation.text} />
          </p>
          <AppInternalLink to={prestation.target} className="link">
            <ShText message={FrontCommonMessages.prestationSeeOther} />
          </AppInternalLink>
        </figcaption>
      </figure>
    </div>
  );
};

export default PrestationOthers;
